import { Component, OnInit, inject } from '@angular/core';
import { MicrosoftAuthService } from '@qaroni-app/auth/services/microsoft-auth.service';

@Component({
  selector: 'qaroni-msal-redirect',
  template: '',
  standalone: false,
})
export class MsalRedirectComponent implements OnInit {
  private microsoftAuthService = inject(MicrosoftAuthService);

  ngOnInit(): void {
    this.microsoftAuthService.handleRedirect();
  }
}
